export const eidErrorsToCount = (() => {
  let result = [
    'VideoID.MaxLengthExceeded',
    'VideoID.ConnectingError',
    'Camera.PermissionDenied',
    'CameraPermission.Denied',
    'Connection.Lost',
    'MicrophonePermission.Denied',
    'Microphone.PermissionDenied',
    'Luminance.TooLow',
    'Luminance.TooHigh',
    'Bandwidth.TooLow',
    'Faces.MultipleFaces',
    'Document.WrongSide',
  ];
  if (!VERIFICATION_APP) {
    result = [
      ...result,
      'Authorization.Invalid',
      'Authorization.Reused',
      'Device.NotSupported',
      'Browser.NotSupported',
      'VideoID.NotSupported',
      'Https.Required',
      'VideoID.InvalidIDType',
      'VideoID.BadRequest',
      'IdType.Invalid',
      'IdType.Unauthorized',
      'IdType.NotSupportedInWebBrowser',
      'IdType.NotSupportedInClient',
      'Camera.NotFound',
      'CameraPermission.Denied',
      'Camera.Unavailable',
      'Camera.InvalidRequirements',
      'CameraResolution.TooLow',
      'Image.Blurred',
      'Microphone.NotFound',
      'MicrophonePermission.Denied',
      'Microphone.PermissionDenied',
      'Connection.Unstable',
      'RTCConnection.Lost',
      'Connection.Error',
      'RTCConnection.Error',
      'RTCConnection.NotAvailable',
      'Document.NotAllowed',
      'Document.Illegitimate',
      'Document.Tampered',
      'Document.Illegible',
      'Barcode.Illegible',
      'DocumentSides.Mismatch',
      'DocumentSides.DataMismatch',
      'Hologram.NotDetected',
      'Document.Glared',
      'Barcode.NotDetected',
      'MaxLength.Exceeded',
      'User.Aborted',
      'UserConnection.Aborted',
      'User.Inactive',
      'Liveness.NotDetected',
      'FaceScanDiscontinuity.Detected',
      'MultipleFaces.Detected',
      'HeadPose.NotFacingFront',
      'Captcha.Invalid',
      'SmileID.NotValidated',
      'Permissions.Refused',
      'VideoID.Error',
      'Service.NotAvailable',
      'AccessToken.Invalid',
    ];
  }
  return result;
})();

export const eidVerificationAppReviewErrors = [
  'Faces.MultipleFaces',
  'DocumentSides.DataMismatch',
  'DocumentSides.Mismatch',
  'Document.Illegitimate',
  'Document.NotAllowed',
  'digital copy',
  'image not matching data',
];
